/**
 * Feature Flags Configuration
 * 機能フラグによる段階的な機能導入を管理
 */

/**
 * 即時DB永続化フラグ
 * true: learningSessionService が即座にDBに保存（フェーズA）
 * false: 従来のメモリ管理（既存動作）
 */
export const USE_IMMEDIATE_PERSIST = process.env.REACT_APP_USE_IMMEDIATE_PERSIST === 'true';

/**
 * 新VideoPlayer使用フラグ（フェーズB用）
 * true: VideoPlayer + video_watch_sessions を使用
 * false: 既存のYouTube直接埋め込み
 */
export const USE_NEW_VIDEO_PLAYER = process.env.REACT_APP_USE_NEW_VIDEO_PLAYER === 'true';

/**
 * デバッグログ出力フラグ
 * true: セッション管理の詳細ログを出力
 * false: 必要最小限のログのみ
 */
export const DEBUG_SESSION_LOGS = process.env.REACT_APP_DEBUG_SESSION_LOGS === 'true' || process.env.NODE_ENV === 'development';

/**
 * フィーチャーフラグの現在値をログ出力
 */
export const logFeatureFlags = () => {
  if (DEBUG_SESSION_LOGS) {
    console.log('🏁 Feature Flags:', {
      USE_IMMEDIATE_PERSIST,
      USE_NEW_VIDEO_PLAYER,
      DEBUG_SESSION_LOGS,
      NODE_ENV: process.env.NODE_ENV
    });
  }
};

/**
 * 開発環境での動的フラグ変更（テスト用）
 */
export const setDevelopmentFlag = (flagName, value) => {
  if (process.env.NODE_ENV === 'development') {
    window[`_dev_${flagName}`] = value;
    console.log(`🔧 Development flag set: ${flagName} = ${value}`);
  }
};

/**
 * 開発環境での動的フラグ取得
 */
export const getDevelopmentFlag = (flagName, defaultValue) => {
  if (process.env.NODE_ENV === 'development' && window[`_dev_${flagName}`] !== undefined) {
    return window[`_dev_${flagName}`];
  }
  return defaultValue;
};

// 初期化時にフラグ状態をログ出力
logFeatureFlags();